<template>
  <div
    :class="{'e1-plan-item': true, 'e1-plan-item--selected': isSelected}"
    @click="onPlanSelect"
  >
    <div v-if="plan.isBestValue" class="e1-plan-item__bv-flag">{{ bannerContent }}</div>
    <div v-else class="e1-plan-item__bv-place"/>
    <h1 class="e1-plan-item__header">{{ header }}</h1>
    <div class="e1-plan-item__text-block">
      <div class="e1-plan-item__pricing">
        <span class="e1-plan-item__price" v-html="price"/>
        <span v-html="trialHint"/>
      </div>
      <div class="e1-plan-item__description">{{ description }}</div>
      <div class="e1-plan-item__promo">{{ promoText }}</div>
    </div>
    <div class="e1-plan-item__button-container">
      <el-button
        :class="{ 'e1-plan-item__btn': true, 'btn-brand': plan.isBestValue, spotlight: plan.isBestValue }">
        Continue
      </el-button>
      <div class="e1-plan-item__bottom-hint">
        {{ bottomHint }}
        <router-link
          class="e1-plan-item__link"
          to="/promoterms"
          @click.stop
        >Terms apply</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'E1PlanItem',
  props: {
    plan: {
      type: Object,
      default: () => {},
    },
    isSelected: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    discountPercentFormatted() {
      return Math.floor(this.discountPercent / 5) * 5;
    },
    header() {
      return this.plan.displayName;
    },
    price() {
      return this.plan.isHolidayPromo
        ? `<span><span class="non-promo-price">${this.plan.displayOriginalPrice}</span> ${this.plan.displayPrice}<br/> <span class="promo-description">for your first year</span></span>`
        : `${this.plan.marketing_price_str}/mo<br/>`;
    },
    trialHint() {
      return this.plan.trialPeriodDays ? ` after the ${this.plan.trialPeriodForDisplay} trial.` : '';
    },
    description() {
      return 'Unlimited access to 30+ Luminary Originals via our app.';
    },
    promoText() {
      if (this.plan.isHolidayPromo) return '';
      return this.discountPercent ? `Save ${this.discountPercentFormatted}% off monthly price` : '';
    },
    discountPercent() {
      return this.plan.discountPercent;
    },
    bottomHint() {
      if (this.plan.isHolidayPromo) return 'Cancel anytime.';
      return this.plan.planTypeString === 'monthly'
        ? 'Auto-billed monthly. Cancel anytime.'
        : `Auto-billed ${this.plan.billingFrequency}. ${this.plan.displayPrice} for your first ${this.plan.displayPaymentPeriod}.`;
    },
    bannerContent() {
      return this.plan.isHolidayPromo ? 'Limited Time Offer' : 'Best Value';
    },
  },
  methods: {
    onPlanSelect() {
      this.$emit('selectPlan', this.plan);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";
.e1-plan-item {
  color: $dark-background;
  position: relative;
  margin: 16px;
  width: 300px;
  height: 300px;
  background: #FFFFFF;
  border: 1px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: border 1s;
  cursor: pointer;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  &--selected {
    border: 1px solid #02AECA;
  }
  &__bv-flag {
    display: flex;
    width: auto;
    padding: 0 10px;
    height: 23px;
    background: $brand;
    border-radius: 2px;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.03em;
    color: #111111;
    flex-flow: column;
    align-items: center;
    justify-content: center;
  }
  &__bv-place {
    width: 94px;
    height: 23px;
    opacity: 0;
  }
  &__header {
    font-family: $serif-bold;
    font-size: 40px;
    line-height: 40px;
    text-align: center;
    margin: 10px 0;
    color: $dark-background;
  }
  &__text-block {
    text-align: center;
  }
  &__pricing {
    font-family: $patron;
    font-size: 13px;
  }
  &__price {
    font-family: $patron;
    font-size: 20px;
  }
  &__description {
    font-family: $patron;
    font-size: 13px;
  }
  &__promo {
    font-family: $patron;
    font-size: 13px;
  }
  &__btn {
    height: 48px;
    width: 190px;
    border: 1px solid $blue;
    color: $blue;
  }
  &__button-container {
    text-align: center;
  }
  &__bottom-hint {
    font-size: 11px;
    line-height: 12px;
    text-align: center;
    color: #BBBBBB;
    padding: 10px 0;
  }
  &__link {
    font-size: 12px;
    color: #666666;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
  }
  &/deep/ .non-promo-price {
    text-decoration: line-through;
    color: #999999;
  }
  &/deep/ .promo-description {
    font-family: $patron;
    font-size: 13px;
  }
}
</style>
